module.exports = __webpack_public_path__ + "static/img/performance06.1dfc6fc8.jpg";